

























































































































import Vue from 'vue';
import _ from 'lodash';

import Requester from '../../requester';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { PlanoDeSaude } from '../../../../back/src/entity/PlanoDeSaude';
import { SimNao, PlanoDeSaudeFormData, PlanoDeSaudeForm } from '../../../../back/src/types';
import { simNaoItens, simNaoNaoSabeItens } from '../../utils/constants';

import Carregando from '../Carregando.vue';
import Confirmar from '../Confirmar.vue';

export default Vue.extend({
  name: 'ThePacientesCadastroInternoPlanosDeSaude',
  components: {
    Carregando,
    Confirmar,
  },
  props: {
    paciente: {
      type: Object as () => Paciente,
      default: {} as Paciente,
    },
  },
  data() {
    return {
      loading: {
        form: false,
        submit: false,
      },
      valid: false,
      dynamicKey: 0,
      form: [] as PlanoDeSaudeForm[],
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
      items: {
        fimCarencia: simNaoNaoSabeItens,
        preferido: simNaoItens,
      },
      SimNao,
    };
  },
  computed: {
    confirmar(): Vue & { open: (titulo: string, mensagem: string) => boolean } {
      return this.$refs.confirmar as Vue & { open: (titulo: string, mensagem: string) => boolean };
    },
    classActions(): string {
      if (this.$vuetify.breakpoint.xsOnly) {
        return 'd-flex justify-space-between pt-0 pb-0';
      }
      return 'd-flex justify-end pt-0 pb-0';
    },
    countPlanosDeSaude(): number {
      let count = 0;
      _.forEach(this.form, (el) => {
        if (!el.remover) {
          count += 1;
        }
      });
      return count;
    },
    formPlanosDeSaude(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formPlanosDeSaude as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
  },
  methods: {
    preferidoUnico(key: number) {
      _.forEach(this.form, (el, index) => {
        if (el.key !== key) {
          this.$set(this.form[index], 'preferido', 'N');
        }
      });
    },
    // eslint-disable-next-line func-names
    novoPlanoDeSaudeDebounce: _.debounce(function () { this.novoPlanoDeSaude(); }, 200),
    novoPlanoDeSaude() {
      this.form.push({
        key: this.dynamicKey,
        id: null,
        nome: '',
        tipo: '',
        fimCarencia: '',
        preferido: this.countPlanosDeSaude > 0 ? SimNao.N : SimNao.S,
        remover: false,
      });
      this.dynamicKey += 1;
    },
    preencheForm() {
      this.loading.form = true;
      if (!_.isEmpty(this.paciente)) {
        this.dynamicKey = 0;
        this.form = [];
        _.forEach(this.paciente.planos_de_saude, (el) => {
          this.form.push({
            key: this.dynamicKey,
            id: el.id,
            nome: el.nome,
            tipo: el.tipo,
            fimCarencia: el.fim_carencia,
            preferido: el.preferido ? SimNao.S : SimNao.N,
            remover: false,
          });
          this.dynamicKey += 1;
        });
      }
      this.loading.form = false;
    },
    // eslint-disable-next-line func-names
    removerDebounce: _.debounce(async function (key: number) { await this.remover(key); }, 200),
    async remover(key: number) {
      if (await this.confirmar.open(
        'Remover plano de saúde',
        'Tem certeza que deseja remover este plano de saúde?',
      ) === false) {
        return;
      }
      const index = _.findIndex(
        this.form as PlanoDeSaudeForm[],
        el => (el.key === key),
      );
      if (index < 0) {
        return;
      }
      this.$set(this.form[index], 'remover', true);
      const indexPreferido = _.findIndex(
        this.form as PlanoDeSaudeForm[],
        el => (el.remover !== true && el.preferido === SimNao.S),
      );
      if (indexPreferido < 0) {
        const indexPrimeiro = _.findIndex(
          this.form as PlanoDeSaudeForm[],
          el => (el.remover !== true),
        );
        if (indexPrimeiro < 0) {
          return;
        }
        this.$set(this.form[indexPrimeiro], 'preferido', SimNao.S);
      }
    },
    // eslint-disable-next-line
    desfazerDebounce: _.debounce(function () { this.desfazer(); }, 200),
    async desfazer() {
      if (await this.confirmar.open(
        'Desfazer edição',
        'Tem certeza que deseja desfazer a edição?\nOs dados alterados serão perdidos.',
      ) === false) {
        return;
      }
      this.$emit('desfazer');
      this.form = [];
      this.formPlanosDeSaude.resetValidation();
      this.preencheForm();
    },
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading.submit = true;
      if (!this.formPlanosDeSaude.validate()) {
        this.loading.submit = false;
        return;
      }
      const formData: PlanoDeSaudeFormData[] = _.map(
        this.form, el => (
          {
            id: el.id,
            paciente_id: this.paciente ? this.paciente.id : null,
            nome: el.nome,
            tipo: el.tipo,
            fim_carencia: el.fimCarencia,
            preferido: el.preferido === SimNao.S,
            remover: el.remover,
          }
        ),
      );
      try {
        const response = await Requester.planoDeSaude.alteraPlanosDeSaude(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('atualizaPlanosDeSaude', response.data);
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Paciente atualizada com sucesso!' });
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading.submit = false;
      }
    },
  },
});
